import {AsyncInlineError, tracer} from '@s-ui/decorators'
import {UseCase} from '@s-ui/domain'

import {GenericUserError} from '../../user/Errors/GenericUserError.js'
import UserServicesFactory from '../../user/Services/factory.js'
import {RenewUserAdsError} from '../Errors/RenewUserAdsError.js'
import {HTTPUserAdsRepository} from '../Repositories/HTTPUserAdsRepository.js'

class RenewUserAdUserAdsUseCase extends UseCase {
  #config
  #getCurrentUserService
  #repository

  static create({config}) {
    return new RenewUserAdUserAdsUseCase({config})
  }

  constructor({config}) {
    super()
    this.#config = config
    this.#getCurrentUserService = UserServicesFactory.getCurrentUserService({config: this.#config})
    this.#repository = HTTPUserAdsRepository.create({config: this.#config})
  }

  @tracer({metric: 'RenewUserAdUserAdsUseCase#execute'})
  @AsyncInlineError()
  async execute({adId} = {}) {
    const userEntity = await this.#getCurrentUserService.execute()
    if (!userEntity) {
      return Promise.reject(
        GenericUserError.create({message: '[RenewUserAdUserAdsUseCase#execute] User must be logged'})
      )
    }

    const [error] = await this.#repository.renew({userEntity, adId})

    if (error) return Promise.reject(RenewUserAdsError.create({message: error.message}))

    return true
  }
}

export const factory = RenewUserAdUserAdsUseCase.create
